export default __webpack_public_path__ + "static/media/mdi_television.8bd6bb57.svg";